import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';
const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page4/Key/E1answerKey.png",
    titleQuestion: [
      {
        num: "1.",
        title: "Xếp các từ trong bông hoa vào nhóm thích hợp.",
        color: "rgb(3, 103, 181)",
        
      },
    ],
    component: MatchDots,
    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [
          {
            boxMatchStyle: {
              position: "absolute",
              top: "91px",
              left: "127px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //0
          {
            boxMatchStyle: {
              position: "absolute",
              top: "91px",
              left: "451px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "91px",
              left: "796px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "279px",
              left: "105px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "279px",
              left: "459px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "812px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "474px",
              left: "155px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "483px",
              left: "455px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //7
          {
            boxMatchStyle: {
              position: "absolute",
              top: "459px",
              left: "784px",
              width: 129,
              height: 129,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //8
          
        ],
        answers: ['0-7', '1-6', '3-4', '4-5', '2-7', '1-8'],
        initialValue: [],
      },
      Layout: `
        <div style='display:flex;font-size:24px'>
          <img src='/img/FriendsPlus/Page4/E1/1.jpg' style='height:15cm' />
        </div>
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />
          <input id='8' type= 'boxMatch' />
          
      `,
    },
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page4/Key/E2answerKey.png",
    titleQuestion: [
      {
        num: "2.",
        title: "<span style='font-weight:500'>Chơi trò chơi</span>: Gửi thư",
        color: "rgb(3, 103, 181)",
        
      },
    ],
    component: MatchDots,
    question: {
      DrawLines: {
        multipleLine: true,
        boxMatch: [
          {
            boxMatchStyle: {
              position: "absolute",
              top: "307px",
              left: "127px",
              width: 181,
              height: 250,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //0
          {
            boxMatchStyle: {
              position: "absolute",
              top: "307px",
              left: "761px",
              width: 181,
              height: 250,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "216px",
              left: "453px",
              width: 264,
              height: 76,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "292px",
              left: "453px",
              width: 312,
              height: 54,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "353px",
              left: "453px",
              width: 203,
              height: 54,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "417px",
              left: "453px",
              width: 203,
              height: 54,
              // backgroundColor: "white",
              // border: "1px solid",
              borderRadius: "50%",
            },
          }, //5
          
          
        ],
        answers: ['0-3', '0-4', '1-2', '1-5'],
        initialValue: [],
      },
      Layout: `
        <div style='font-size:25px;color:black'>
          Tìm hộp thư phù hợp với mỗi phong thư.<br>  
          <b style=' color:rgb(190 95 69)'>G</b>: Mỗi phong thư ghi nội dung hoặc cách viết của nhóm thư trên hộp thư A hoặc B.
        </div>
        <div style='font-size:24px'>
          <img src='/img/FriendsPlus/Page4/E2/1.jpg' style='height:105mm;margin-left:-80px' />
        </div>
          <img src='/img/FriendsPlus/Page4/E2/2.jpg' style='height:45mm' />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          
          
      `,
    },
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page4/Key/E3answerKey.png",
    component: Circle_Write,

    titleQuestion: [
      {
        num: "3",
        title: `
			Tìm danh từ chung và danh từ riêng trong đoạn văn dưới đây.
		
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
    textareaStyle:{width:300},
		question: {
			Write: {

				inputStyle: { width:750, padding: 20 },
				answers: ["người, anh hùng, tuổi, tên, nơi, quê, thôn, xã, huyện, tỉnh, nhiệm vụ, cán bộ","Kim Đồng, Việt Nam, Nông Văn Dền, Nà Mạ, Trường Hà, Hà Quảng, Cao Bằng"],
				initialValue: [],
			},
			Circle: {
				initialWordStyle: {},
				// initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
				selectWordStyle: {padding:"0",borderBottom:"2px solid black" },
				limitSelect: 21,
				listWords: [
					`&emsp; Kim_Đồng là người anh_hùng nhỏ tuổi của Việt_Nam. Anh tên thật là Nông_Văn_Dèn (Có nơi viết là Nông_Văn_Dền), quê ở thôn Nà_Mạ, xã Trường_Hà, huyện Hà_Quảng, tỉnh Cao_Bằng.
          Trong lúc làm nhiệm_vụ liên lạc cho cán_bộ cách mạng, anh đã anh dũng hi sinh. Khi đó anh vừa tròn 14 tuổi.
          `,
					
				],
				answers: ['0-0', '1-0', '2-0', '3-4', '4-4', '5-0', '6-0', '7-4', '8-0', '0-2', '0-26', '0-36', '0-44', '0-48', '0-52', '0-56', '0-6', '0-8', '0-12', '0-16', '0-20', '0-30', '0-38', '0-42', '0-46', '0-50', '0-84', '0-92', '0-122'],

				initialValue: [],
			},
			Layout: `
    <div style='width:24cm;margin-bottom:20px'>
      <b>a.</b>&ensp;Gạch dưới các danh từ trong đoạn văn.<br>
      <input id='0' type='Circle'/>
    </div>
      <b>b</b>&ensp;Viết những danh từ tìm được trong đoạn văn ở bài tập a vào nhóm thích hợp
			<div>
        <div style='text-align:center'>
          

        </div>
      </div>

      <div style='display:flex;margin-top:20px'>
        <div>
          <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
            Danh từ chung
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
            <textarea id='0' rows='4'></textarea>
          </div>
        </div>
        <div style='margin-left:200px'>
          <div style='margin-left:22px;background:rgb(3 103 181);border:2px solid ;font-weight:bold;color:white; border-radius:10px; padding:4px 10px;width:7cm;text-align:center '>
            Danh từ riêng
          </div>
          <div style='border:2px solid rgb(3 103 181); border-radius:10px;padding:4px 0px;width:82mm;'>
            <textarea id='1' rows='4'></textarea>
          </div>
        </div>
      </div>

        
         `,
		},},
 
 
};

export default json;
